import React from 'react'

import './styles.scss'
import { getStaticImage } from 'utils/statics'
import { getPrimaryContact } from '../utils'
import { ParsedContacts } from './utils'

export const SidePopupContact = ({ contact, toggle }) => (
  <div className='side-popup-contact'>
    <figure className='side-popup-contact__avatar'>
      <img
        src={contact.avatarUrl || getStaticImage('/icons/orange-brand/icon-avatar.svg')}
        alt={contact.name || ''}
        onError={event => {
          event.target.src = getStaticImage('/icons/orange-brand/icon-avatar.svg')
          event.onerror = null
        }}
      />
    </figure>
    <div className='side-popup-contact__info'>
      <p className='side-popup-contact__name'>{contact.name || ''}</p>
      <span className='side-popup-contact__contact'>{getPrimaryContact(contact)}</span>
    </div>
    <ul className='side-popup-contact__details'>
      {contact.addresses?.length ? (
        <li className='side-popup-contact__details-item'>
          <strong className='side-popup-contact__details-label'>Dirección</strong>
          {ParsedContacts({ type: 'address', data: contact.addresses })}
        </li>
      ) : null}
      {contact.emails?.length ? (
        <li className='side-popup-contact__details-item'>
          <strong className='side-popup-contact__details-label'>Correo</strong>
          {ParsedContacts({ type: 'email', name: contact.name, data: contact.emails, toggle })}
        </li>
      ) : null}
      {contact.org ? (
        <li className='side-popup-contact__details-item'>
          <strong className='side-popup-contact__details-label'>Organización</strong>
          <span>{contact.org}</span>
        </li>
      ) : null}
      {contact.phones?.length ? (
        <li className='side-popup-contact__details-item'>
          <strong className='side-popup-contact__details-label'>Teléfono</strong>
          {ParsedContacts({ type: 'phone', name: contact.name, data: contact.phones, toggle })}
        </li>
      ) : null}
      {contact.urls?.length ? (
        <li className='side-popup-contact__details-item'>
          <strong className='side-popup-contact__details-label'>Página web</strong>
          {ParsedContacts({ type: 'url', data: contact.urls })}
        </li>
      ) : null}
    </ul>
  </div>
)
